export const earn = {
  jdzb: "Gains simples",
  jryd: "Finance intelligente, progrès ensemble",
  jrbk: "Rejoignez Biking Gains Simples, des opportunités illimitées pour maximiser vos actifs numériques",
  zbz: "En cours de gain",
  ljsy: "Bénéfices cumulés",
  zrsy: "Bénéfices d'hier",
  hq: "Flexible",
  dq: "Terme",
  cknh: "APY de référence",
  sqjd: "Progression de la subscription",
  sg: "Souscrire",
  qbcp: "Tous les produits",
  cz: "Réinitialiser",
  qx: "Durée",
  question1: "1. Qu'est-ce que Gains Simples ?",
  question1_text: "Gains Simples est une plateforme tout-en-un créée par Biking pour aider les utilisateurs à découvrir diverses opportunités de produits de garde de jetons. Actuellement, nous proposons Gains Simples (boursorama), et davantage de produits seront disponibles bientôt.",
  question2: "2. Qu'est-ce que l'APY de référence ?",
  question2_text: "Les bénéfices de Gains Simples représentent les intérêts sur les jetons déposés. L'APY de référence est le taux d'intérêt annualisé. Par exemple, pour un produit : les premiers 1000U à 12% APY, au-delà à 2% APY, soit 14% au total.",
  question3: "3. Quand les intérêts commencent-ils à générer ?",
  question3_text: "Selon le produit souscrit, la date de début des intérêts peut varier. Pour le produit USDT à intérêts quotidiens : les intérêts commencent à 2h le lendemain (UTC+8), et les intérêts de la veille sont versés à 5h (UTC+8) le jour suivant.",
  question4: "4. Qu'est-ce que le montant restant investissable ?",
  question4_text: "Le montant restant investissable est la quantité disponible pour ce produit financier<br/>Montant restant = Quota total - Montant déjà souscrit",
  xzmbfs: "Choisir comment déposer/acheter des jetons",
  nhsyl: "Rendement annuel et durée :",
  sl: "Quantité",
  qitou: "Minimum",
  max: "Maximum",
  kzcsl: "Ceci est la quantité transférable depuis le compte de fonds",
  sykt: "Restant investissable",
  syktsl: "Le montant restant investissable est la quantité que vous pouvez encore souscrire",
  syktsx: "Montant restant = Quota total - Montant déjà souscrit (ne dépassant pas {amount}{coin} par personne)",
  jlgz: "Règles des奖励",
  jd1: "Tranche 1 : Premiers {amount}{coin}",
  ptjl: "奖励 de la plateforme",
  jd2: "Tranche 2 : Au-delà de {amount}{coin}",
  jd22: "Tranche",
  jd3: "Tranche 3 : Au-delà de {amount}{coin}",
  grsgsx: "Limite de subscription personnelle : {amount}{coin}",
  gz: "Règle",
  sgsj: "Heure de subscription",
  xianzai: "Maintenant",
  qxsj: "Date de début des intérêts",
  lxrz: "Crédit des intérêts",
  c2c: "Achat C2C",
  lhxz: "Choix flexible, meilleurs prix",
  lcjd: "Processus simple, transaction rapide",
  crszhb: "Déposer des crypto depuis le portefeuille ou la plateforme",
  zcsl: "Quantité d'actifs",
  dzsy: "Bénéfices crédités",
  lcxx: "Informations sur le produit",
  zt: "Statut",
  sh: "Racheter",
  sgje: "Montant de subscription",
  sgzj: "Les premiers {amount}{coin} de fondos peuvent gagner {value}% APY de奖励",
  dyklqje: "Au-delà de {amount}{coin} peut gagner {value}% APY de奖励",
  grsgd: "La limite de subscription personnelle est de {amount} à {amount2}{coin}",
  shsl: "Quantité à racheter",
  srshsl: "Entrer la quantité à racheter",
  ksh: "Rachetable :",
  haode: "OK",
  sgcg: "Subscription réussie",
  shcg: "Rachats réussi",
  zcsg: "Resouscrire",
  sjdzsl: "Quantité réellement créditée",
  shsj: "Heure de remboursement",
  jssj: "Heure de règlement",
  yjsdd: "Ordres réglés",
  jyjl: "Historique des transactions",
  hqjdzb: "Gains flexibles",
  sy: "Bénéfices",
  wwc: "Non terminé",
  xmlx: "Type de projet",
  hqjdzbcp: "Les gains flexibles sont des produits financiers sécurisés créés par Biking, avec retrait à tout moment et intérêts horaires",
  nh: "Annualisé",
  zhzchz: "Transfert rapide entre comptes d'actifs",
  qsrsl: "Veuillez entrer la quantité",
  yjsddmx: "Détails des bénéfices réglés",
  mx: "Détails",
  qwsmrz: "Aller à la vérification d'identité",
  jxwcsmrz: "1. Cette活动 est réservée aux utilisateurs ayant complété la vérification d'identité, une seule participation par utilisateur",
  dqcked: "2. La limite de dépôt à terme est de {min}~{max}{coin} par utilisateur, le système rachète automatiquement à échéance",
  cpbntjsh: "3. Ce produit ne peut pas être racheté avant échéance",
  anzh: "4. Une fois le produit épuisé, le bouton devient gris",
  smrzyh: "L'activité est réservée aux utilisateurs ayant complété la vérification d'identité",
  jxcjyc: "Chaque utilisateur éligible ne peut participer qu'une seule fois",
  ygsy: "Bénéfices estimés",
  scqx: "Durée de blocage",
  qixian: "Jour {min} (sur {max} jours au total)",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/earn/fr.js